import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { ILocalNotification } from '../../../../models/LocalNotifications';
import { Topics } from '../../../../models/LocalNotificationTopics';
import { invalidateAllSocialMediaPostReports, useInfiniteSocialMediaPosts } from '../../../../queries';
import { baseStyleSheet } from '../../../styles/styles';
import { LoadingSpinner } from '../../LoadingSpinner';
import { LocalNotificationObserver } from '../../LocalNotificationObserver';
import { SHOW_ENGAGEMENT_COLUMN, styleSheet } from './styles';

interface Props {
	children: React.ReactNode;
	postStatus: Api.PostStatus[] | null;
	userId?: string;
}

export const SocialMediaReportingTable = ({ postStatus, userId, children }: Props) => {
	const socialMediaPostsQuery = useInfiniteSocialMediaPosts({
		selectedPostStatus: postStatus,
		meta: {
			errorLogging: {
				category: 'SocialMediaReportingTable',
				action: 'GetSocialReports-Error',
			},
		},
		selectedUserId: userId,
	});
	const onNotification = (notification: ILocalNotification<string>) => {
		if (notification.topic === Topics.EDIT_SOCIAL_POST) {
			invalidateAllSocialMediaPostReports();
		}
	};
	return (
		<>
			{socialMediaPostsQuery.status === 'success' ? (
				<>
					<div className={css(baseStyleSheet.tableColumnHeader, styleSheet.header)}>
						<div className={css(styleSheet.nameColumn)}>Post Title/Status</div>
						<div className={css(styleSheet.createdColumn)}>Created On</div>
						<div className={css(styleSheet.platformColumn)}>Platform(s)/Account Used</div>
						{SHOW_ENGAGEMENT_COLUMN && <div className={css(styleSheet.engagementColumn)}>Engagement (per page)</div>}
						<div className={css(styleSheet.viewPostColumn)}>View Post On Platform</div>
					</div>
					<div className={css(styleSheet.body)}>
						{children}
						{socialMediaPostsQuery.isFetchingNextPage && (
							<LoadingSpinner className={css(styleSheet.loading)} type='large' />
						)}
					</div>
				</>
			) : (
				<div className={css(styleSheet.noneFound)}>No Posts Found</div>
			)}
			<LocalNotificationObserver onNotificationReceived={onNotification} topic={Topics.EDIT_SOCIAL_POST} />
		</>
	);
};
